export default __webpack_public_path__ + "static/media/preview-matrix.04d9b633.png";